module.exports = __webpack_public_path__ + "static/poutama-9d92071038ad5984fab75d6d92eb7f1a.svg";